
import { DateTime, Interval} from "luxon"

export class IntervalService{
    duration_forward = []
    
    constructor(schedule, start, days_forward = 14){
        this._intervals = schedule.intervals
        this._timezone = schedule.timezone
        this.start = start
        this.days_forward = days_forward

        this.weeks_forwards()
    }

    get timezone(){
        return this._timezone
    }

    get intervals(){
        return this._intervals
    }

    weeks_forwards(){
        this.duration_forward = Interval.fromDateTimes(
            this.start.startOf("day"), 
            this.start.plus({days: this.days_forward - 1}).endOf("day"))
          .splitBy({ day: 1 }).map(d =>{
            return {
                date: d.start,
                interval: this.spot_interval(d.start)
            }
          });
        
    }

    spot_interval(datetime){

        let intervals = JSON.parse(JSON.stringify(this.intervals))
        let day = datetime.weekday 
        
        for (const interval of intervals.reverse()) {

            if (interval.mode == 'DAYOFWEEK') {
                if (interval.day_of_week.includes(day == 0 ? 6 : day - 1)) {
                    if(interval.is_workday) {
                        return this.time_obj(interval) 
                    }
                    else 
                        return undefined
                }
            }else {
                if(interval.is_workday){
                    let duration

                    if(interval.str_date_end){
                        
                        duration = Interval.fromDateTimes(
                            DateTime.fromISO(interval.str_date_start),
                            DateTime.fromISO(interval.str_date_end)
                        )
                        
                        if(duration.contains(datetime)){
                            return this.time_obj(interval)
                        }

                    }else{

                        duration = DateTime.fromJSDate(new Date(interval.str_date_start))

                        if(datetime.startOf('day') == duration.startOf('day')){
                            return this.time_obj(interval)
                        }

                    }

                }
            }
        }
        return undefined
    }

    time_str_to_obj(str_time, correction = false){

        if(!str_time){
            return undefined
        }

        let str_arr = str_time.split(':')

        if(correction){
            return {
                hour: Number(str_arr[0]) == 0 ? 23 : Number(str_arr[0]), 
                minute: Number(str_arr[1]) == 0 && Number(str_arr[0]) == 0 ? 59 : Number(str_arr[1]) 
            }
        }

        return {
            hour: Number(str_arr[0]), 
            minute: Number(str_arr[1])
        }

    }

    time_obj(interval){
        return {
            start: this.time_str_to_obj(interval.str_time_start),
            end: this.time_str_to_obj(interval.str_time_end, true)
        }
    }

}

